import React, { Component } from 'react';
// import { FormattedMessage, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import config from '../../../src/globs/config'


class PayerSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingBalance: {},
      sapCode: '',
      disabledFetchbalance: false,
      firstTimebalanceFetch: true,
      customerStatus: true,
      payerIndex: 1,
      currentPayerBalance: null
    };
  }

  componentDidMount() {
    const { props } = this;
    console.log('props>>>>>>>>>>>>>>>>>>>#', props);
    console.log('props.......***', this.props)
    // this.props.customer.business && this.props.customer.business.payers.forEach((payer) => {
    //   const path = `${config.apiContextPath}/so/sales_officers/${this.props.user.id}/businesses/${this.props.customer.business.id}/fetch_balance?payer_sap_code=${payer.payer_sap_code}`;
    //   props.dataLoad({
    //     key: 'payers',
    //     url: path,
    //   });
    // });

    if(this.props.customer.business.payers.length > 0) {
      this.balanceRefresh(this.props.customer.business.payers[0].payer_sap_code);

    }

  }

  componentDidUpdate(prevProps, prevState) {
    // Only update when API status changes from PENDING to complete
    // Add guards to prevent infinite loops in React 19
    if (prevProps.ajaxStatuses.payers === 'PENDING' &&
      this.props.ajaxStatuses.payers === '') {
        console.log('inn fetchBalanceFromSap');
      // To hit api for all payers for first time
      if (this.state.firstTimebalanceFetch) {
        const payers = this.props.customer.business.payers;
        const payerIndex = this.state.payerIndex;
        console.log('payer ===>', payers.length, payerIndex);
        // Only update if payerIndex hasn't already been incremented
        if (payers.length >= payerIndex && prevState.payerIndex === payerIndex) {
          this.setState({
            payerIndex: payerIndex + 1,
            fetchingBalance: {
              ...this.state.fetchingBalance,
              [this.state.sapCode]: false,
            },
            disabledFetchbalance: false,
          }, () => {
            const sapCode = this.props.customer.business.payers[payerIndex] &&
            this.props.customer.business.payers[payerIndex].payer_sap_code;
            if (sapCode) {
              this.balanceRefresh(sapCode);
            } else {
              this.setState({
                firstTimebalanceFetch: false,
              });
            }
          });
        }
      } else {
        // Only update if fetchingBalance or disabledFetchbalance actually needs to change
        const currentFetching = this.state.fetchingBalance[this.state.sapCode];
        if (currentFetching !== false || this.state.disabledFetchbalance !== false) {
          this.setState({
            fetchingBalance: {
              ...this.state.fetchingBalance,
              [this.state.sapCode]: false,
            },
            disabledFetchbalance: false,
          });
        }
      }
    }
  //   if (prevProps.ajaxStatuses.payers === 'PENDING' &&
  //    this.props.ajaxStatuses.payers === '') {
  //      console.log('hiiii', false);
  //     this.setState({
  //       customerStatus: false,
  //     });
  // } else {
  //   console.log('hiiii', true);
  //   this.setState({
  //     customerStatus: true,
  //   });

  // }
}

  balanceRefresh = (sapCode) => {
    const { props } = this;
    // console.log('props are.........', props.customer);
    // const payer_sap_code = props.payers[0].payer_sap_code;
    // const path = 'https://navendor-jde-staging.herokuapp.com/so/sales_officers/141/businesses/2022/fetch_balance?payer_sap_code=0000183090';
    const path = `${config.apiContextPath}/sales_officers/${props.user.id}/businesses/${props.customer.business.id}/fetch_balance?payer_sap_code=${sapCode}`;
    props.dataLoad({
      key: 'payers',
      url: path,
    });
    this.setState({
      sapCode,
      disabledFetchbalance: true,
      fetchingBalance: {
        ...this.state.fetchingBalance,
        [sapCode]: true,
      },
    });
  }

  render() {
    const { state, props } = this;
    // console.log('props===>', props);
    // const user = {
    //   payer_name: props.user.name,
    //   payer_sap_code: props.user.sap_code,
    //   sap_digital_order_balance: props.user.sap_digital_order_balance,
    //   orders_not_invoiced_price: props.user.orders_not_invoiced_price,
    // };
    return (
      <div className="lr-customer-pop">
        <div className="lr-customer-pop__modal multiple-payers-pop">
          <div>
            {/* <h2 className="lr-pop-heading"><FormattedMessage id="Multiple.Payers.text" /></h2> */}
            <h2 className="lr-pop-heading">Multiple Payers</h2>
            <form>
              {/* {
                <props.rowComponent
                  payer={user}
                  balanceRefresh={this.balanceRefresh}
                  fetchingBalance={state.fetchingBalance}
                  disabledFetchbalance={state.disabledFetchbalance}
                  onSubmit={props.onSubmitPayer}
                  selectedPayer={props.selectedPayer}
                />
              } */}
              {
                   props.payers && props.payers.map(payer =>
                  (<props.rowComponent
                    key={payer.payer_sap_code}
                    payer={payer}
                    customer={props.customer}
                    user={props.user}
                    balanceRefresh={this.balanceRefresh}
                    fetchingBalance={state.fetchingBalance}
                    disabledFetchbalance={state.disabledFetchbalance}
                    onSubmit={props.onSubmitPayer}
                    customerStatus = {state.customerStatus}
                    selectedPayer={props.selectedPayer}
                  />))
              }
            </form>
          </div>
          {/* <div>
            
              <PayerRow />
            
          </div> */}
          <div className="lr-button-row">
            <button onClick={props.onOkClick}>
              {/* <span><FormattedMessage id="All.okText" /></span> */}
              <span>Ok</span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

PayerSelect.propTypes = {
  payers: PropTypes.shape({}).isRequired,
  ajaxStatuses: PropTypes.shape({
    fetchBalanceFromSap: PropTypes.string,
  }),
};

PayerSelect.defaultProps = {
  ajaxStatuses: undefined,
};


export default PayerSelect;
